import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { Notification } from '../../../../common/notification'
import { Table } from '../../../../common/table'
import { selectFilingStatus, selectLoading } from '../../store/slice'
import { COLUMN_IDS, ROW_IDS } from './helper'
import classes from './index.module.scss'

export const FilingStatus = () => {
  const data = useSelector(selectFilingStatus())
  const isLoading = useSelector(selectLoading('filingStatus'))

  const schema = Object.keys(COLUMN_IDS).map((key) => {
    const colId = COLUMN_IDS[key]
    const title = 'companySummary.filingStatus.' + key

    return {
      colId,
      title,
      isI18n: true,
      render: (dataCell, { rowId }) => {
        switch (colId) {
          case COLUMN_IDS.TYPE:
            return <Translate value={`companySummary.filingStatus.${rowId}`} />
          case COLUMN_IDS.RECORD_AVAILABILITY:
            return data[ROW_IDS[rowId]]
          default:
            return dataCell
        }
      },
    }
  })

  return (
    <Element className={classes.container}>
      {isLoading ? (
        <Loading />
      ) : !data || !Object.keys(data).length ? (
        <Notification />
      ) : (
        <Table
          ids={Object.keys(ROW_IDS)}
          getDataFromRedux={selectFilingStatus}
          isLoading={isLoading}
          schema={schema}
        />
      )}
    </Element>
  )
}
